import { render, staticRenderFns } from "./batchListOfRegular.vue?vue&type=template&id=1aae2bc2&scoped=true&"
import script from "./batchListOfRegular.vue?vue&type=script&lang=js&"
export * from "./batchListOfRegular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aae2bc2",
  null
  
)

export default component.exports